// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var AccordionSummaryStyledJs = require("./AccordionSummaryStyled.js").default;

var make = AccordionSummaryStyledJs;

exports.make = make;
/* make Not a pure module */
